//news接口
import states from '../state/pageNews';
import mutations from '../mutations/pageNews';
import actions from '../actions/pageNews';
import getters from '../getters/pageNews';

export default {
  namespaced: true,
  states,
  mutations,
  actions,
  getters
};